// 宁东e招
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        {
            title: 'CA办理/续费',
            href: '/cahandle?featurecode=ndez',
            activeReg: /(^\/cahandle*)/,
            click:`window.open('/cahandle?featurecode=ndez')`
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '宁东e招电子招投标平台',//全称
        title2: '宁东e招',//简称
        jc_title: '宁东e招',//简称
        citycode:'640000',//城市编号
        planName:'ndez',
        caType:'ndezcaapply',
        caHref:'https://online.cwca.com.cn/',//CA申请链接
        meta: {
            description: '宁东e招电子招投标平台,交易平台,招投标,电子交易平台',
            keywords: '宁东e招电子招投标平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/ndez/favicon.ico',
        logoUrl: '/ndez/images/logo.png',
        loginImgUrl: '/ndez/images/loginImg.png',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://eztb.ningdongcloud.com/#/login?plan=ndez',
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://eztb.ningdongcloud.com/#/login?plan=ndez',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://ezdl.ningdongcloud.com/otc/#/login?plan=ndez&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://ezdl.ningdongcloud.com/otc/#/login?plan=ndez&mRole=tender',
                title: '采购人登录',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://ezpb.ningdongcloud.com/?plan=ndez',
                title: '评标登录',
            }
        ],
        userRolesZfcg:[
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://eztb.ningdongcloud.com/#/login?plan=ndez',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://ezdl.ningdongcloud.com/otc/#/login?plan=ndez&mRole=agent',
                subHref: 'http://zfcgdl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://ezdl.ningdongcloud.com/otc/#/login?plan=ndez&mRole=tender',
                title: '采购人登录',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://ezpb.ningdongcloud.com/?plan=ndez',
                title: '评标登录',
            }
        ],
        friendLinks:[
            {
                href: 'https://ggzyjy.fzggw.nx.gov.cn',
                title: '宁夏回族自治区公共资源交易中心网站'
            },
            {
                href: 'https://www.ccgp-ningxia.gov.cn/index.html',
                title: '宁夏回族自治区政府采购网'
            },
            {
                href: 'https://www.nx.gov.cn/',
                title: '宁夏回族自治区人民政府网站'
            },
            {
                href: 'http://www.cebpubservice.com/',
                title: '中国招投标公共服务平台'
            },
            {
                href: '',
                title: ''
            },
        ],
        tel: '400-630-6886', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'nxhuizezhao@163.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '宁夏宁东科技创业投资有限公司',  //运营公司名称
        companyAddress: '宁东科技孵化园',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'宁ICP备16001392号-5',
        gwIcp:'',
        closeAboutTitle: true,
        products: [
            {
                title: 'xxxx',
                href: 'xxxxx'
            },
        ],
    },
    theme:{
        whiteColor: '#FFFFFF',
        primaryColor: '#000',
        successColor: '#000',
        warningColor: '#000',
        dangerColor: '#000',
        infoColor: '#000',
        navBgColor: '#000',
        navTextColor: '#000',
        navTextActiveColor: '#000'
    },
    proxy: {
        '/web': {
            target: 'http://ndez.ningdongcloud.com/',
            changeOrigin:true,
        },
        '/standalonfile': {
            target: 'http://ndez.ningdongcloud.com/',
            changeOrigin:true,
        },
    },
}